import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { GeolocalisationResponse } from '@icilalune/types';

@Injectable({
  providedIn: 'root',
})
export class GeoLocalizationService {
  geoLocalizationState$: ReplaySubject<GeolocalisationResponse> =
    new ReplaySubject<GeolocalisationResponse>(1);

  localizeMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          const pos = {
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          };
          this.geoLocalizationState$.next({ status: 'yes', geoPoint: pos });
        },
        () => {
          this.geoLocalizationState$.next({
            status: 'no',
            geoPoint: undefined,
          });
        }
      );
    } else {
      this.geoLocalizationState$.next({ status: 'error', geoPoint: undefined });
    }
  }
}
